import { findIndex } from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Asset from './modules/asset/asset';
import Listener from './modules/listener';
import UI from './modules/ui';
import UIStatic from './modules/ui-static';

export const MUTATE_AUTH = 'MUTATE_AUTH';
export const MUTATE_MULTISIG_ACCOUNTS = 'MUTATE_MULTISIG_ACCOUNTS';
export const MUTATE_MULTISIG_ACCOUNT = 'MUTATE_MULTISIG_ACCOUNT';
export const REMOVE_MULTISIG_ACCOUNT = 'REMOVE_MULTISIG_ACCOUNT';
export const MUTATE_ACTIVITIES = 'MUTATE_ACTIVITIES';
export const ADD_ACTIVITY = 'ADD_ACTIVITY';

Vue.use(Vuex);

interface IUser {
  pk: string;
  pb: string;
  multisigAccounts: any[];
  activities: any[];
}

interface IAuthState {
  login: boolean;
  user: IUser;
}

interface IState {
  auth: IAuthState;
  endpoints: any[];
  networkType: any;
}


export default new Vuex.Store({
  state: {
    auth: {
      login: false,
      user: {
        pk: '',
        pb: '',
        multisigAccounts: [],
        activities: [],
      }
    },
    endpoints: [
      {
        web: 'http://api.beta.catapult.mijin.io:3000',
        webSocket: 'ws://api.beta.catapult.mijin.io:3000'
      }
    ],
    networkType: 'NetworkType.MIJIN_TEST',
  },
  getters: {
      getAuth: ( state: IState ) => state.auth,
      getUserPK: (state: IState) => state.auth.user.pk,
      getEndpoint: (state: IState) => state.endpoints[0].web,
      getSocketEndpoint: (state: IState) => state.endpoints[0].webSocket,
      getMultisigAccounts: (state: IState) => state.auth.user.multisigAccounts,
      getNetworkType: (state: IState) => state.networkType,
      getActivities: (state: IState) => state.auth.user.activities,
  },
  mutations: {
    [MUTATE_AUTH](state: IState, payload: IAuthState) {
      state.auth = payload;
    },
    [MUTATE_MULTISIG_ACCOUNTS](state: IState, payload: any[]) {
      state.auth.user.multisigAccounts = payload;
    },
    [MUTATE_MULTISIG_ACCOUNT](state: IState, payload: any) {
      const theIndex = findIndex(state.auth.user.multisigAccounts, (multisigAccount) => {
        return payload.account.equals(multisigAccount.account);
      });
      if (theIndex === -1) {
        state.auth.user.multisigAccounts.unshift(payload);
      } else {
        state.auth.user.multisigAccounts.splice(theIndex, 1, payload);
      }
    },
    [REMOVE_MULTISIG_ACCOUNT](state: IState, payload: any) {
      const theIndex = findIndex(state.auth.user.multisigAccounts, (multisigAccount) => {
        return payload.account.equals(multisigAccount.account);
      });
      if (theIndex !== -1) {
        state.auth.user.multisigAccounts.splice(theIndex, 1);
      }
    },
    [MUTATE_ACTIVITIES](state: IState, payload: any[]) {
      state.auth.user.activities = payload;
    },
    [ADD_ACTIVITY](state: IState, payload: any) {
      const theIndex = findIndex(state.auth.user.activities, (activity) => {
        return payload.transactionInfo!.id === activity.transactionInfo!.id;
      });
      if (theIndex === -1) {
        state.auth.user.activities.unshift(payload);
      }
    }
  },
  actions: {
  },
  modules: {
    ui: UI,
    uiStatic: UIStatic,
    asset: Asset,
    listener: Listener,
  },
  plugins: [createPersistedState({
    key: 'LuxTagSamurai',
    paths: ['auth', 'ui', 'asset'],
  })],
});
